module.exports = __webpack_public_path__ + "static/image-05-b@2x-37bea213019b385424282c00226ea8c5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/pages/case-studies/designmuseum/image-05-b@2x.jpg
// module id = 373
// module chunks = 3627797113349 20562973939449 33019919093843